import get from './get';
import store from './store';
import update from './update';
import destroy from './destroy';
import deleteImage from './deleteImage';
import duplicate from './duplicate';
import downloadMultimedia from "./downloadMultimedia";

export default {
    get,
    store,
    update,
    destroy,
    deleteImage,
    duplicate,
    downloadMultimedia
};



// WEBPACK FOOTER //
// ./src/app/services/checklist_group/index.js